import { TerraformWorkflowTool } from "types/generated";

/**
 * The Terraform workflow tool options to use in a select.
 */
export const TERRAFORM_WORKFLOW_TOOL_OPTIONS = [
  { label: "OpenTofu", value: TerraformWorkflowTool.OpenTofu },
  { label: "Terraform (FOSS)", value: TerraformWorkflowTool.TerraformFoss },
  { label: "Custom", value: TerraformWorkflowTool.Custom },
];

/**
 * Gets the label value for the specified workflow tool.
 * @param value the workflow tool enum value
 * @returns the label value, or the raw enum value if the tool is unknown.
 */
export function workflowToolLabel(value: TerraformWorkflowTool): string {
  const option = TERRAFORM_WORKFLOW_TOOL_OPTIONS.find((o) => o.value === value);
  if (option) {
    return option.label;
  }

  return value;
}
